var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.usage !== undefined
    ? _c(
        _setup.Button,
        {
          staticClass: "btn-sm p-0 px-1",
          nativeOn: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _setup.showPanel.apply(null, arguments)
            },
          },
        },
        [_c("small", [_vm._v(_vm._s(_setup.usage))])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }